<template>
    <div class="col-sm-10 col-md-8 col-lg-6 align-self-center">
        <div class="card h-100">
            <div class="card-body p-sm-3 p-md-5">
                <h1>{{$t('done_thanks')}}</h1>
                <template v-if="!completed">
                    <h5><i class="fa fa-circle-o-notch fa-spin fa-fw"></i> Een moment geduld aub...</h5>
                    <p class="mt-3">{{$t('done_answers_compressed', { progress: uploadsLeft } )}}</p>
                </template>
                <template v-else>
                    <p>{{$t('done_answers_sent')}}</p>
                </template>
                <div class="progress">
                    <div :class="['progress-bar progress-bar-striped', completed ? '' : 'progress-bar-animated']" role="progressbar" :aria-valuenow="progress" aria-valuemin="0" aria-valuemax="100" :style="{width: progress + '%'}"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        mounted() {
            this.interval = setInterval(() => {
                // Check if there are failed uploads and restart them.
                if(this.$state.uploads.failed.length) {
                    let args = this.$state.uploads.failed.shift();
                    this.$api.uploadVideo(...args);
                } else if(this.completed) {
                    clearInterval(this.interval);
                }
            }, 3000);
        },
        data() {
            return {
                interval: undefined
            }
        },
        computed: {
            progress() {
                let completed = this.$state.uploads.completed;
                let in_progress = this.$state.uploads.in_progress;
                let failed = this.$state.uploads.failed.length;
                return Math.ceil(completed / (in_progress + completed + failed) * 100);
            },
            completed() {
                return this.$state.uploads.in_progress <= 0 && this.$state.uploads.failed.length <= 0;
            },
            uploadsLeft() {
                return this.$state.uploads.in_progress + this.$state.uploads.failed.length;
            }
        },
        watch: {
            completed: {
                handler() {
                    if(this.completed) {
                        this.$api.testDone();
                        this.setCanCloseApplication(true);
                    }
                },
                immediate: true
            }
        }
    }
</script>
